import HttpService from '~/services/httpService';
import { adaptInvoiceListFromAPI } from '~/adapters/adaptInvoice';
import { adaptOrderStatementListContent } from '~/adapters/adaptOrders';
import { adaptQueryParams } from '~/adapters/adaptQueryParams';
import { PAGINATION } from '~/helpers/constants';
import { prepareInvoiceFilterQueryParams } from '~/helpers/Invoices.utils';

const get = HttpService.get;
const baseUrl = 'invoices';

async function getInvoices(resellerDocument: string, params?: any) {
  return await get(baseUrl, { params: { ...params, resellerDocument } }).then(
    (response) => response,
    (error) => {
      throw error;
    },
  );
}

export async function listInvoices(resellerDocument: string) {
  return await getInvoices(resellerDocument).then(
    (response) => (
      {
      invoiceList: adaptInvoiceListFromAPI(response.data.data),
      pagination: response.data.metadata.pagination,
    }),
    (error: any) => {
      throw error;
    },
  );
}

export async function filterInvoices(
  resellerDocument: string,
  filters: any = {},
  pagination = { ...PAGINATION },
) {
  const params = adaptQueryParams<any, any>(filters, pagination, prepareInvoiceFilterQueryParams);
  const response = await getInvoices(resellerDocument, params);

  return {
      invoiceList: adaptInvoiceListFromAPI(response.data.data),
      pagination: response.data.metadata.pagination,

  };
}

export async function listInvoiceStatement(orderNumber: string | number, resellerDocument: string) {
  return await get(`${baseUrl}/${orderNumber}/statement`, { params: { resellerDocument } }).then(
    (response) => adaptOrderStatementListContent(response.data.data),
    (error) => {
      throw error;
    },
  );
}

export async function listInvoicesDownload(resellerDocument: string, params?: any) {
  return await get(`${baseUrl}/download`, { params: { ...params, resellerDocument } }).then(
    (response) => response.data,
    (error) => {
      throw error;
    },
  );
}
